import "./index.scss";
import { VideoProps } from "./types";
import DefaultVideo from "./DefaultVideo";
import InModalVideo from "./InModalVideo";
import React from "react";

const Video = (props: VideoProps) => {
  const { openInModal, ...otherProps } = props;
  const VideoComponent = openInModal === true ? InModalVideo : DefaultVideo;
  return <VideoComponent {...otherProps} />;
};

export default Video;
